import { Paper } from "@mui/material";
import { Collections, Inventory, Storage } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { useAccount } from "wagmi";

import { useUser } from "@dzambalaorg/provider-user";
import { NodeEnv } from "@dzambalaorg/constants";
import type { IUser } from "@framework/types";
import { BusinessType, ChainLinkV2SupportedChains, RatePlanType } from "@framework/types";
import { List } from "@dzambalaorg/ui-kit";

const data = [
  { text: "pages.loot.contracts.title", link: "/loot/contracts", icon: <Collections /> },
  { text: "pages.loot.boxes.title", link: "/loot/boxes", icon: <Inventory /> },
  { text: "pages.loot.tokens.title", link: "/loot/tokens", icon: <Storage /> },
];

export const LootSection = () => {
  const { profile } = useUser<IUser>();
  const { chainId = 0 } = useAccount();

  if (profile?.merchant?.ratePlan === RatePlanType.BRONZE) {
    return null;
  }

  if (process.env.BUSINESS_TYPE === BusinessType.B2B) {
    return null;
  }

  if (process.env.NODE_ENV === NodeEnv.production && !ChainLinkV2SupportedChains[chainId]) {
    return null;
  }

  if (process.env.NODE_ENV === NodeEnv.production) {
    return null;
  }

  return (
    <Paper sx={{ mb: 2 }}>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.mechanics.loot" />
          </List.Subheader>
        }
      >
        {data.map(({ text, icon, link }) => (
          <List.ItemButton<typeof RouterLink> key={text} component={RouterLink} to={link}>
            <List.ItemIcon>{icon}</List.ItemIcon>
            <List.ItemText>
              <FormattedMessage id={text} />
            </List.ItemText>
          </List.ItemButton>
        ))}
      </List>
    </Paper>
  );
};
